import React, { useId } from 'react';

interface LogoProps {
  className?: string;
  variant?: 'default' | 'compact' | 'modern' | 'gradient-text' | 'stacked';
}

/** The 4K Labs mark exactly as 4klabs.ai draws it: the violet tile with white "4K»" and "Labs" in the same gradient. */
const Logo: React.FC<LogoProps> = ({ className = '', variant = 'modern' }) => {
  const id = useId().replace(/[^\w-]/g, '');
  const box = `g4kBox${id}`;
  const txt = `g4kTxt${id}`;
  const height = variant === 'compact' ? 26 : 30;
  return (
    <svg
      className={`inline-block shrink-0 ${className}`}
      height={height}
      viewBox="0 0 140 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="4K Labs"
      style={{ width: 'auto' }}
    >
      <rect width="60" height="36" rx="8" fill={`url(#${box})`} />
      <text x="8" y="25" fill="white" fontSize="20" fontWeight="bold" fontFamily="system-ui, -apple-system, sans-serif">4K</text>
      <path d="M38 16L42 18L38 20" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M45 16L49 18L45 20" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <text x="68" y="25" fill={`url(#${txt})`} fontSize="22" fontWeight="bold" fontFamily="system-ui, -apple-system, sans-serif">Labs</text>
      <defs>
        <linearGradient id={box} x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#8B5CF6" /><stop offset="100%" stopColor="#7C3AED" /></linearGradient>
        <linearGradient id={txt} x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stopColor="#8B5CF6" /><stop offset="100%" stopColor="#7C3AED" /></linearGradient>
      </defs>
    </svg>
  );
};

export default Logo;
